var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button",on:{"click":_vm.goToUploadHistoryPage}},[_vm._v("Upload History")])
}
var staticRenderFns = []

export { render, staticRenderFns }